// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2MB75","actions":"GroupTable_actions__2xYYs","deleteModalFooter":"GroupTable_deleteModalFooter__Q0DZN"};